exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-menu-item[data-v-2d2bbdc2]{\n\tfont-size: 14px;\n\t/*font-weight: 600;*/\n}\n.none[data-v-2d2bbdc2]{\n\tcolor: bfcbd9;\n}\n.blue[data-v-2d2bbdc2]{\n\tcolor: #1890ff;\n}\n\n", ""]);

// exports
